import { render, staticRenderFns } from "./back-nav-btn.vue?vue&type=template&id=c8dc56fa&scoped=true&"
import script from "./back-nav-btn.vue?vue&type=script&lang=js&"
export * from "./back-nav-btn.vue?vue&type=script&lang=js&"
import style0 from "./back-nav-btn.vue?vue&type=style&index=0&id=c8dc56fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dc56fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
